$(document).ready(function () {
  $('.marquee-slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    cssEase: 'linear',
    centerMode: true,
    variableWidth: true,
    autoplaySpeed: 0,
    speed: 6000,
    arrows: false,
    focusOnSelect: true,
    pauseOnHover: true,
    lazyLoad: 'ondemand',
    // responsive: [
    //   {
    //     breakpoint: 992,
    //     settings: {
    //       autoplay: false, 
    //       arrows: true,
    //       speed: 1500,
    //       slidesToShow: 2,
    //       centerMode:false,
    //       focusOnSelect: true,
    //     }
    //   },
    // ]
  });
});
$('.marquee-slider').on('init', function () {
  let styleBackup = '';
  let currentState = '';
  let restOfTimeout = 500;

  $('.marquee-slider .slick-track').hover(
    function () {
      styleBackup = $(this).attr('style');
      currentState = getComputedStyle(this).transform;
      let translateDone = parseFloat(currentState.split(',')[4]) * (-1);

      let regex = /translate3d\(([^,]*),/gm;
      let m;
      if ((m = regex.exec(styleBackup)) !== null) {
        let translateNeed = parseFloat(m[1]) * (-1);
        let slideWidth = $('.marquee-slider .slick-slide').first().width();
        let speed = 5000 / slideWidth;
        restOfTimeout = (translateNeed - translateDone) * speed;
      }

      $('.marquee-slider').slick('slickPause');
      $(this).css('transform', currentState);
    },
    function () {
      $(this).attr('style', styleBackup.replace('5000ms', restOfTimeout + 'ms'));
      $('.marquee-slider').slick('slickPlay');
    }
  );
});
// Shop By Brand
$(document).ready(function () {
  $('.brand-logo-slider').slick({
    slidesToShow: 9,
    slidesToScroll: 9,
    infinite: false,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      }
    ]
  });
});
// Slider
$(document).ready(function () {
  $('.products-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    rows: 1,
    infinite: true,
    speed: 300,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          rows: 1,
        }
      }
    ]
  });
});
// Customer Review slick slider
$(document).ready(function () {
  $('.customer-review-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: $('.slider-button-two-rows--prev'),
    nextArrow: $('.slider-button-two-rows--next'),
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
});
// Customer Review slick slider
$(document).ready(function () {
  $('.featured-items-slider').slick({
    slidesToShow: 3,
    arrows: false,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '85px',
          autoplay: true
        }
      }
    ]
  });
});
// Dropdown menu
$(document).ready(function () {
  $(".list-menu .list-menu-item.has-sub-child").on("mouseenter", function () {
    // Remove 'active' class from all items and hide the dropdowns
    $(".list-menu .list-menu-item").removeClass("active-menu");
    $("body").addClass('menu-item-hovered');
    $(this).addClass("active-menu");
  }).on("mouseleave", function () {
    // Remove 'active' class and hide the dropdown when hover ends
    $(this).removeClass("active-menu");
    $("body").removeClass('menu-item-hovered');
  });
});

// Filter Dropdown
$(document).ready(function () {
  $(document).on('click', '.active-facets-vertical-filter', function (e) {
    e.preventDefault();
    if ($(e.target).closest('facet-remove').length > 0) {
      return;
    }
    $(".product-grid-container").toggleClass("active");
    $(".facets").toggleClass("active");
    if ($(".product-grid-container").hasClass('active')) {
      $("#product-grid").addClass("grid--3-col-desktop");
    } else {
      $("#product-grid").addClass("grid--4-col-desktop");
      $("#product-grid").removeClass("grid--3-col-desktop");
      $("body").removeClass("filter-modal-active")
    }
  });
});
$(document).ready(function () {
  $(".mobile-close-icon").on("click", function () {
    $(this).parents('details').removeAttr('open');
    $(this).parents('.mobile-facets__disclosure').removeClass('menu-opening');
    $('.facets-vertical').removeClass('facets-vertical-active');
    $('body').removeClass('overflow-hidden-mobile');
  });
});
// Affiliate Faq
$(document).ready(function () {
  // Open the first FAQ item by default
  const $firstItem = $('.faq-item').first();
  const $firstAnswer = $firstItem.find('.faq-answer');
  const $firstArrow = $firstItem.find('.question-arrow');

  $firstAnswer.stop(true, true).slideDown(300).addClass('open');
  $firstArrow.addClass('open');

  // Handle click events for each FAQ item
  $('.faq-item').each(function () {
    const $item = $(this);
    const $question = $item.find('.faq-question');
    const $answer = $item.find('.faq-answer');
    const $arrow = $item.find('.question-arrow');

    $question.on('click', function () {
      const isOpen = $answer.is(':visible');
      $('.faq-answer').slideUp(300).removeClass('open');
      $('.question-arrow').removeClass('open');
      if (!isOpen) {
        $answer.stop(true, true).slideDown(300).addClass('open');
        $arrow.addClass('open');
      }
    });
  });
});

// Products Faq
$(document).ready(function () {
  $('.product-faq-item').each(function () {
    const $item = $(this);
    const $question = $item.find('.product-faq-question');
    const $answer = $item.find('.product-faq-answer');
    const $arrow = $item.find('.product-faq-arrow');

    $question.on('click', function () {
      const isOpen = $answer.is(':visible'); // Check if the answer is already open

      // Close all answers and arrows, remove active class from all items
      $('.product-faq-answer').slideUp(300).removeClass('open'); // Slide up all open answers
      $('.product-faq-arrow').removeClass('open'); // Reset all arrows
      $('.product-faq-item').removeClass('active'); // Remove active class from all items

      // If current answer was not open, slide it down, show the arrow, and add active class to the item
      if (!isOpen) {
        $answer.stop(true, true).slideDown(300).addClass('open'); // Slide down the clicked answer
        $arrow.addClass('open'); // Rotate the arrow
        $item.addClass('active'); // Add active class to the clicked item
      }
    });
  });
});

// Input on click class
$(document).ready(function () {
  var selector = '.contact_form_class .field__input';
  $(selector).on('focus blur input', function () {
    var $this = $(this);
    var $label = $this.parent().children('.field__label');
    if ($this.val() === '') {
      $label.removeClass('has-value');
    } else {
      $label.addClass('has-value');
    }
  });
  // Handle autofill or initial values on page load
  $(window).on('load', function () {
    $(selector).each(function () {
      var $this = $(this);
      var $label = $this.parent().children('.field__label');
      if ($this.val() !== '') {
        $label.addClass('has-value');
      }
    });
  });
});

// Details Accordian
$(document).ready(function () {
  // $( ".filters-form-details .facets__disclosure-vertical:nth-last-child(2)" ).attr( "open", "open" );
  // $( "#FacetsWrapperMobile .js-filter:nth-last-child(3)" ).attr( "open", "open" );
});

$(document).ready(function () {
  $(".mobile-facets__disclosure .mobile-facets__open-wrapper").on("click", function () {
    // Check if the element has an "active" class or is in an active state
    // $( "#FacetsWrapperMobile .js-filter:nth-last-child(3)" ).attr( "open", "open" );
  });
});

// Account Select
// Account Select
const $menu = $(".selector-container.mobile-view");
const $selectBtn = $menu.find(".dropdown");
const $sBtnText = $menu.find(".select-btn");
const $sBtnImage = $menu.find(".dropdown img"); // Select the image inside the button

$selectBtn.on("click", function () {
  $menu.toggleClass("active-mobile");
});

$(document).ready(function () {
  const $firstItem = $menu.find(".list-items li").first();
  $firstItem.addClass("active"); // Add 'active' class to the first item
  // Set the button text to the first item's text
  $sBtnText.text($firstItem.find(".option-text").text());
  // Set the button image to the first item's image
  $sBtnImage.attr("src", $firstItem.find(".option-image").attr("src"));
});

$menu.find(".list-items li").each(function () {
  $(this).on("click", function () {
    // Update the text of the button
    $sBtnText.text($(this).find(".option-text").text());
    // Update the image of the button
    const $optionImage = $(this).find(".option-image"); // Get the image inside the clicked option
    $sBtnImage.attr("src", $optionImage.attr("src")); // Set the button image src to the selected option's image

    // Close the menu after selecting
    $menu.removeClass("active-mobile");
  });
});

function validateNumberInput(input) { input.value = input.value.replace(/[^0-9]/g, ''); }

$(document).ready(function () {
  // Find the element with the class pagination__item--current
  var currentItem = $('.pagination__item--current');
  currentItem.closest('li').prev().addClass('show-page');
});

$(function () {
  // Check if the window width is greater than 767px
  if ($(window).width() < 767) {
    $(".products-slider .slick-arrow").on("click", function (event) {
      event.preventDefault();
      var $parent = $(this).closest('.product-content');
      var topToScrollTo = $parent.offset().top;
      $("html, body").stop().animate({ scrollTop: topToScrollTo }, 1000);
    });
  }
});

$(document).ready(function () {
  $(document).on('change', 'input[class="quantity__input"]', function () {
    $('input[class="custom__quantity__input"]').val($(this).val());
  })
});

document.addEventListener("DOMContentLoaded", function () {
  let referrer = document.referrer;
  let isComingFromTesterCollection = referrer.includes("tester");
  let productDetailsPageExists = window.location.href.includes("/products/");
  if (isComingFromTesterCollection && productDetailsPageExists) {
    let buttons = document.querySelectorAll("variant-selects label");

    buttons.forEach(button => {
      if (button.innerText.toLowerCase().includes("tester")) {
        button.click();
      }
    });
  }
});

// document.addEventListener('DOMContentLoaded', function () {
//   const lazyImages = document.querySelectorAll('img.lazy2');
//   const imageObserver = new IntersectionObserver((entries, observer) => {
//     entries.forEach((entry) => {
//       if (entry.isIntersecting) {
//         const img = entry.target;
//         const dataSrc = img.getAttribute('data-src');

//         if (dataSrc) {
//           img.src = dataSrc;
//           img.removeAttribute('data-src');
//           img.classList.remove('lazy2'); // Optional: Remove the class once loaded
//         }

//         observer.unobserve(img);
//       }
//     });
//   });

//   lazyImages.forEach((img) => imageObserver.observe(img));
// });